import { put, takeLatest } from "redux-saga/effects";
import { requestOccupancyTrackerList, requestOTStatusUpdate,requestOccupancyTrackerListFloorWise,requestLeadReportData,requestSalesReportData,requestGetTopDealWon, requestOccupancyGraphFloorWise, requestOtFloorSuiteDetails } from "../../../services/occupancyTracker";
import {
  fetchOccupancyListRequest,
  fetchOccupancyListSuccess,
  fetchOccupancyListFailure,
  updateOtStatusRequest,
  updateOtStatusSuccess,
  updateOtStatusFailure,
  fetchOccupancyListFloorRequest,
  fetchOccupancyListFloorSuccess,
  fetchOccupancyListFloorFailure,
  fetchLeadReportRequest,
  fetchLeadReportSuccess,
  fetchLeadReportFailure,
  fetchSalesReportRequest,
  fetchSalesReportSuccess,
  fetchSalesReportFailure,
  fetchTopDealWonRequest,
  fetchTopDealWonSuccess,
  fetchTopDealWonFailure,
  fetchOccupancyGraphRequest,
  fetchOccupancyGraphSuccess,
  fetchOccupancyGraphFailure,
  fetchOccupancyGraphSuiteRequest,
  fetchOccupancyGraphSuiteSuccess,
  fetchOccupancyGraphSuiteFailure,

} from "../../reducers/occupancyTracker";

export function* watchOccupancyTrackerSaga() {
  yield takeLatest(fetchOccupancyListRequest, fetchTrackerList);
  yield takeLatest(fetchOccupancyListFloorRequest, fetchTrackerListFloor);
  yield takeLatest(updateOtStatusRequest, updateOccupancyStatus);
  yield takeLatest(fetchLeadReportRequest, fetchLeadReportData);
  yield takeLatest(fetchSalesReportRequest,fetchSalesReportData)
  yield takeLatest(fetchTopDealWonRequest,fetchTopDealWon)
  yield takeLatest(fetchOccupancyGraphRequest, fetchGraphFloorWise);
  yield takeLatest(fetchOccupancyGraphSuiteRequest, fetchGraphSuiteFloorWise);
}

function* fetchTrackerList({ payload }) {
  try {
    const response = yield requestOccupancyTrackerList(payload);
    yield put(fetchOccupancyListSuccess(response));
  } catch (error) {
    yield put(fetchOccupancyListFailure("Failed to get list of Tracker"));
  }
}

function* fetchTrackerListFloor({ payload }) {
  try {
    const response = yield requestOccupancyTrackerListFloorWise(payload);
    yield put(fetchOccupancyListFloorSuccess(response));
  } catch (error) {
    yield put(fetchOccupancyListFloorFailure("Failed to get Lead Report"));
  }
}

function* fetchLeadReportData({ payload }) {
  try {
    const response = yield requestLeadReportData(payload);
    yield put(fetchLeadReportSuccess(response));
  } catch (error) {
    yield put(fetchLeadReportFailure("Failed to get Lead Report"));
  }
}

function* fetchSalesReportData({ payload }) {
  try {
    const response = yield requestSalesReportData(payload);
    yield put(fetchSalesReportSuccess(response));
  } catch (error) {
    yield put(fetchSalesReportFailure("Failed to get list"));
  }
}

function* fetchTopDealWon({ payload }) {
  try {
    const response = yield requestGetTopDealWon(payload);
    yield put(fetchTopDealWonSuccess(response));
  } catch (error) {
    yield put(fetchTopDealWonFailure("Failed to get list"));
  }
}

function* updateOccupancyStatus({ payload }) {
  try {
    const response = yield requestOTStatusUpdate(payload);
    yield put(updateOtStatusSuccess(response));
  } catch (error) {
    yield put(updateOtStatusFailure("Failed to update OT Status"));
  }
}

function* fetchGraphFloorWise({ payload }) {
  try {
    const response = yield requestOccupancyGraphFloorWise(payload);
    yield put(fetchOccupancyGraphSuccess(response));
  } catch (error) {
    yield put(fetchOccupancyGraphFailure("Failed to get Lead Report"));
  }
}

function* fetchGraphSuiteFloorWise({ payload }) {
  try {
    const response = yield requestOtFloorSuiteDetails(payload);
    yield put(fetchOccupancyGraphSuiteSuccess(response));
  } catch (error) {
    yield put(fetchOccupancyGraphSuiteFailure("Failed to get Floor Suite Details"));
  }
}
